export const header = `
<header
  style="background-color:#414141;height:70px;padding-left:2vw;padding-right:2vw;position:relative;display:flex;justify-content:space-between;align-items:center;gap:1rem">
  <img class="logo" src="/surepart-logo.png" alt="SurePart Logo" />
  <div
    class="react-loading-skeleton"
    style="width:100%;max-width:600px;height:40px"></div>
  <div
    class="react-loading-skeleton"
    style="width:40px;height:40px;min-width:40px"></div>
</header>`;
